export default __webpack_public_path__ + "static/media/back2.97bb5ca5.png";